import React from 'react';
import { Twitter } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-attribution">
          <p className="footer-founder">Founded by people who love research</p>
          <p className="footer-description">Independent research lab</p>
        </div>
        
        <div className="footer-links">
          <a
            href="https://x.com/kolosianlabs"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X (Twitter)">

            <Twitter size={20} strokeWidth={1.5} />
          </a>
          <a
            href="https://medium.com/@imsarthakshrma"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer">

            Medium
          </a>
        </div>
        
        <div className="footer-copyright">
          <p>© 2025 Kolosian. All rights reserved.</p>
        </div>
      </div>
    </footer>);

};

export default Footer;